import { render, staticRenderFns } from "./rule_history_list.html?vue&type=template&id=0332481a&scoped=true&name=rule_history_list&external"
import script from "./rule_history_list.js?vue&type=script&lang=js&external"
export * from "./rule_history_list.js?vue&type=script&lang=js&external"
import style0 from "./rule_history_list.less?vue&type=style&index=0&id=0332481a&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0332481a",
  null
  
)

export default component.exports